import { useMemo } from 'react';
import { findBrokerByCode, isActiveBroker } from '../utils/broker-status.util';
import { useBrokers } from './use-brokers.hook';

/**
 * Corretora da tela de detalhe (`/brokers/:id`, onde `id` é o PartyCode).
 *
 * Header e abas chamam com o mesmo código, então compartilham a query em cache.
 * `isInactive` só é true depois de carregar: enquanto carrega as ações ficam
 * travadas sem aviso; corretora não encontrada conta como inativa, igual à Api.
 */
export function useBrokerDetails(
  brokerId: string,
  options: { enabled?: boolean } = {}
) {
  const { data, isLoading, isError } = useBrokers(
    { search: brokerId },
    options
  );

  const broker = useMemo(
    () => findBrokerByCode(data?.data, brokerId),
    [data, brokerId]
  );
  const isActive = isActiveBroker(broker);

  return {
    broker,
    isLoading,
    isError,
    isActive,
    isInactive: !isLoading && !isError && !isActive,
  } as const;
}
